<template>
  <div>
    <div class="bg" />
    <h1 id="title">רכישת ערכה</h1>
    <div class="card-container md-layout md-alignment-center-center">
      <div
        class="md-layout-item md-medium-size-33 md-small-size-33 md-xsmall-size-100 card-holder"
        v-bind:key="card.id"
        v-for="card in cards"
      >
        <PackageCard
          @click.native="packagePicked(card)"
          :title="card.name"
          :price="card.price"
          :description="card.description"
          :originalPrice="card.original_price"
          :isDiscounted="card.discount"
          :features="card.features"
          :mapType="card.mapType"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PackageCard from "./PackageCard";
import * as fb from "../firebase";

// eslint-disable-next-line
const analytics = firebase.analytics()

export default {
  name: "PackageChoiceScreen",
  beforeCreate: () => {
    if (this.$cookies.get("token") === null) {
      window.location.href = "https://app.tzav-rishon.co.il";
    }
  },
  data: () => {
    return {
      cards: []
    };
  },
  created() {
    this.fetchData();
    analytics.logEvent("screen_view", {
      screen_name: "Package Choice Screen"
    });
  },
  methods: {
    packagePicked(pkg) {
      localStorage.setItem("pkg", pkg.id);
      localStorage.setItem("amountToPay", pkg.formmated_price);
      localStorage.setItem("pkgName", pkg.name)
      this.$router.push("/checkout");

      analytics.logEvent("add_to_cart", {
        currency: 'ILS',
        item_category: 'Digital Goods',
        item_name: pkg.name,
        item_id: pkg.id,
        price: pkg.price,
        screen_name: "Package Choice Screen"
      });

      analytics.logEvent('begin_checkout', {
        currency: "ILS"
      })
    },
    fetchData() {
      fb.db
        .collection("packages")
        .get()
        .then(querySnapshot => {
          const cardsData = querySnapshot.docs.map(doc => doc.data());
          this.cards = cardsData;
        });
    }
  },
  components: {
    PackageCard
  }
};
</script>

<style scoped>
.card-holder {
  margin-bottom: 16px;
  margin-left: 4vw;
  margin-right: 4vw;
}

.bg {
  background-image: url(https://storage.googleapis.com/tzav-rishon-web-assets/blurred_backpacks_bg.png);
  background-size: cover;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  position: absolute;
}

.card-container {
  padding-top: 10%;
  margin-left: 16px;
  margin-right: 16px;
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  /* Styles */
  .card-container {
    padding-top: 30%;
  }
}

#title {
  position: absolute;
  top: 32px;
  color: white;
  left: 50%;
  white-space: nowrap;
  transform: translate(-50%, 0);
}
</style>